import { SWRConfiguration } from 'swr';

import { usePendingOrgInvites, usePendingTenants } from '@/hooks/useSwr';
import { OrganizationBaseSchema, TenantSchema } from '@/types/schema';

export interface GroupedInviteSchema extends OrganizationBaseSchema {
  workspaceInvites?: TenantSchema[];
  showWorkspaces: boolean;
}

export const useGroupedOrgInvites = (
  options?: SWRConfiguration & { skip?: boolean }
) => {
  const workspaceInvites = usePendingTenants({
    ...options,
  });
  const orgInvites = usePendingOrgInvites({
    ...options,
  });

  const invites: GroupedInviteSchema[] | undefined = orgInvites.data?.map(
    (invite) => {
      const workspaces = workspaceInvites.data?.filter(
        (w) => w.organization_id === invite.id
      );
      const hasSameNamedWorkspace = workspaces?.some(
        (w) => w.display_name === invite.display_name
      );
      const showWorkspaces = !hasSameNamedWorkspace;
      return {
        ...invite,
        workspaceInvites: workspaces,
        showWorkspaces,
      };
    }
  );

  const reload = () => {
    workspaceInvites.mutate();
    orgInvites.mutate();
  };
  return {
    data: invites,
    isLoading: workspaceInvites.isLoading || orgInvites.isLoading,
    isValidating: workspaceInvites.isValidating || orgInvites.isValidating,
    error: workspaceInvites.error || orgInvites.error,
    reload,
  };
};
